'use strict'

var hasDims = require('./has_dimensions.js')
var hasHighlight = require('./has_highlight.js')
var getImageCropRect = require('./get_image_crop_rect.js')

function getCropParams(image, options) {
    var params = {}
    if (hasDims(image) && hasHighlight(image)) {
        // if the image has dimensions and a highlight, call getImageCropRect
        var rect = getImageCropRect(image, options.width, options.height)
        // convert the rect into a string `0,0,100,100` as imgix expects
        params.rect = [rect.x, rect.y, rect.w, rect.h].join(',')
    } else {
        // if the image doesn't have dims/highlight, fallback to imgix crop
        // options
        // crop=faces works only when fit=crop
        params.fit = 'crop'
        params.crop = 'faces'
    }
    return params
}

module.exports = function getImgixUrl(image, options) {
    // validate image
    if (typeof(image) !== 'object') throw new Error('Invalid image: not an object')
    if (! image.url) throw new Error('Invalid image: url required')

    // validate options
    if (typeof(options) !== 'object') throw new Error('options required')
    if (! options.width && ! options.height)
        throw new Error('at least include width or height')
    if (! options.quality) throw new Error('quality required')
    if (! options.IMGIX_URL) throw new Error('IMGIX_URL required')

    // apply default options
    // devicePixelRatio is made optional mostly for testability;
    // other modules don't need to provide them
    var defaultDevicePixelRatio = 2
    if (typeof window !== 'undefined') {
        defaultDevicePixelRatio = window.devicePixelRatio // eslint-disable-line
    }

    if (options.devicePixelRatio == null)
        options.devicePixelRatio = defaultDevicePixelRatio
    if (options.crop == null)
        options.crop = true

    // varruct imgix base URL
    var url = image.url
    // remove the schema
    url = url.replace(/https?:\/\//, '')
    // remove the hostname
    url = url.slice(url.indexOf('/'))
    // prepend the imgix hostname
    url = 'https://' + options.IMGIX_URL + url

    // varruct imgix query string
    var params = {
        q: options.quality,
        dpr: Math.round(options.devicePixelRatio),
        auto: 'format',
        fit: 'max',
    }
    // when there is one dimension param provided,
    // imgix display it according to the aspect ratio of the original image
    // currently use case is gallery carousel
    // fit=max is used widely; fit=crop currently only being used for gallery
    // images
    if (options.width) params.w = options.width
    if (options.height) params.h = options.height

    if (options.crop) {
        var new_params = getCropParams(image, options)
        if (new_params.rect) params.rect = new_params.rect
        if (new_params.fit) params.fit = new_params.fit
        if (new_params.crop) params.crop = new_params.crop
    }

    // convert every key/value in the params object to an array of `key=value`
    // strings, and then join them with `&`
    var query = Object.keys(params).map(function (key) {
        return key + '=' + params[key]
    }).join('&')

    return url + '?' + query
}
